export default function reportPackageSummariesDirective() {
  return {
    template: require('./report-package-summaries.html'),
    controller: 'PRReportPackageSummariesController',
    controllerAs: 'prReportPackageSummariesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackages: '=',
    },
  };
}
